import React, { useEffect, useState, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { Loading } from '../../../../redux/action';
import { Button } from '@mui/material';
import * as Utility from '../../../../core/utility';
import dayjs from 'dayjs';
import './campaign-details.scss';
import { ListService, PublicService ,CommonService} from '../../../../core/services';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { DummyCampaignImage } from '../../../../config/config';
import DeliverableInfo from '../../../../components/deliverables/deliverables';
import CampaignDetailTitle from './campaign-detail-title';
import { ApplyRestrictionPopup } from '../../../../components/popup/apply-restriction-popup';
import { FbConversionTrack } from '../../../../core/services/FbConversionTrackEvents';
import CommonPopUp from "../../../../components/popup/common-popup";
import { MuiOtpInput } from "mui-one-time-password-input";
import { LoadingButton } from "@mui/lab";
import { FormValidation } from "../../../../core/utility";
import * as gtUtil from "../../../../core/utility";

const fbConversionTrack: FbConversionTrack = new FbConversionTrack();

interface Props {
    UserReducer: any;
    UserID: any;
    loading: (data: any) => void;
    selectCampaign: any;
}
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

//const applyCampaignFlowService: ApplyCampaignService = new ApplyCampaignService();
const methods: Utility.Methods = new Utility.Methods();
const listService: ListService = new ListService();
const publicService: PublicService = new PublicService();
const commonService:CommonService = new CommonService();

const CampaignDetails: React.FC<Props> = (props: Props) => {
    const [campaignDetail] = useState(props.selectCampaign);
    const myref: any = useRef(null);
    const productref: any = useRef(null);
    const navigate = useNavigate();
    const [applyButtonClass, setApplyButtonClass] = useState('Apply Now');
    const [disabledApplyBtn, setDisabledApplyBtn] = useState<boolean>(false);
    const [open_wf_otp, set_open_wf_otp] = useState<boolean>(false);
    const [phoneOtpError, setPhoneOtpError] = useState<boolean>(false);
    const [otpWhatsAppValue, setOtpWhatsAppValue] = React.useState<string>('')
    const [invited_number, set_invited_number] = useState('');

    const formValidation = new FormValidation();

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        if(applyButtonClass == "Apply Now" && props?.UserReducer == null){
            setOpen(true)
        }
    };
    const handleClose = () => 
        {
            setOpen(false);
            set_already_user(false);
        }
    const [applyRestrictionPopup, setApplyRestrictionPopup] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [SM_ID, setSM_ID] = useState(0);
    const [whatsapp_flow, setwhatsapp_flow] = useState<boolean>(false);
    const [campaignDetailForDeliverable, setCampaignDetailForDeliverable] = useState<any>(null);
    const [stateToUpdateUserReducer, setStateToUpdateUserReducer] = useState<boolean>(false);
    const [already_user, set_already_user] = useState(false);
    const [applyRestrictionData, setApplyRestrictionData] = useState({
        followers: {
            status: false,
        },
        subscription: {
            status: false,
        },
        social_connect: {
            status: false,
        },
    });
    const [checkInfType, setCheckInfType] = useState({
        status:false,
    })

    useEffect(() => {
        setSM_ID_Handler();
        (async () => {
            try {
                if (props.selectCampaign){
                    const fb_track_response = await fbConversionTrack.trackViewContent({userData: props.UserReducer, campaignData: props.selectCampaign})
                }
            } catch (error) {
                console.error('Error fetching campaign details:', error);
            }
        })()
    }, [props, stateToUpdateUserReducer])

    useEffect(() => {
        getApplyRestrictionData();
        getCampaignDetailForDeliverable();
    }, [SM_ID])


    useEffect(() => {
        // const refDiv = document.getElementById("shortDescription")
        if (myref.current && campaignDetail) {
            myref.current.innerHTML = campaignDetail.campaign_description
            if (campaignDetail.hasOwnProperty('product_description')) {
                if (productref.current) {
                    productref.current.innerHTML = props.selectCampaign.product_description;
                }
            }
        }
    }, [myref.current, campaignDetail])

    useEffect(() => {
        (async function ApplyCampaign() {
            props.loading(true);
            listService.get_applied_campaigns({
                influencerId: props?.UserReducer?.influencer_id || props.selectCampaign.influencerId,
                campaignId: props.selectCampaign.campaign_id
            }).then((res: any) => {
                if (res.data.status) {
                    res.data.rows.find((element: any) => {
                        if (element.campaign_id === props.selectCampaign.campaign_id) {
                            if (element.status === 'Accepted' || element.status === 'Rejected') {
                                // setDisabledApplyBtn(true);
                                setApplyButtonClass(element.status);
                            }

                            if (element.status === 'Negotiating' || element.status === 'Pending' || element.status === 'Shortlisted') {
                                // setDisabledApplyBtn(false);
                                setApplyButtonClass('Applied');
                            }
                        }
                    })
                }
            })
                .catch((error) =>
                    console.warn('Influencer applied campaign List Error :: ' + error)
                )
                .finally(() => props.loading(false));
        })();
    }, [props])


    // when connect the social media update the campaign details for active the deliverables
    async function getCampaignDetailForDeliverable() {
        const response = await publicService.campaignDetailForDeliverable(
            null,
            props.selectCampaign.campaign_id + '',
            SM_ID
        );
        if (response.data.status.status) {
            setCampaignDetailForDeliverable(response.data.rows);
        }
    }

    async function applyCampaign() {
        try {
            if (applyButtonClass === 'Apply Now') {
                const res = await listService.getApplyRestriction({
                    influencerId: ((props.selectCampaign?.influencerId && props.selectCampaign?.influencerId > 0) ? props.selectCampaign?.influencerId : props.UserReducer.influencer_id),
                    platform: props.selectCampaign.campaign_platform,
                    smId: SM_ID,
                    campaignId: props.selectCampaign.campaign_id,
                    accountId: props?.UserReducer?.account_id
                });
                if (res.status === gtUtil.Constants.SUCCESS) {
                    setApplyRestrictionData(res.data);
                    if (res.data?.followers?.status && res.data?.subscription?.status && res.data?.social_connect?.status) {
                        // let generateUrl = Object.entries(methods._GetQueryParams(window.location.search)).map(([k, v]) => `${k}=${v}`).join('&');
                        if(res.data.checkInfType.status){
                            // navigate(`/influencer/campaign/proposal?campaignId=${props?.selectCampaign?.campaign_id}&smId= ${whatsapp_flow} ? ${SM_ID} : ${res.data?.sm_id}`);
                            navigate(`/influencer/campaign/proposal?campaignId=${props?.selectCampaign?.campaign_id}&smId=${res.data?.sm_id}`);
                        }else{
                            setCheckInfType({
                                status:true,
                            })
                        }
                    } else {
                        setApplyRestrictionPopup(true);
                    }
                }
            }else{
                const response: any = await listService.getAppliedSm_id({
                    influencerId: props?.UserReducer?.influencer_id,
                    campaign_id: props.selectCampaign.campaign_id
                })
        
                if (response.status === gtUtil.Constants.SUCCESS && response.data.length > 0) {
                    navigate(`/influencer/campaign/proposal?campaignId=${props?.selectCampaign?.campaign_id}&smId=${response.data[0].sm_id || 0}`);
                }
            }
        } catch (err) {
                console.log('error in handleCampaignApply', err);
        }
    }
    async function applyWithSignUp() {
        try {
            const res = await listService.get_invited_influencer({
                influencerId: ((props.selectCampaign?.influencerId && props.selectCampaign?.influencerId > 0) ? props.selectCampaign?.influencerId : props.UserReducer.influencer_id),
                campaignId: props.selectCampaign.campaign_id,
            });
            if(res.status === gtUtil.Constants.SUCCESS){
                if(res.data.already_user === true){
                    set_already_user(true);
                }else{
                    sessionStorage.setItem("campaignId",props.selectCampaign.campaign_id);
                    navigate(`/signup/influencer`, { state: { influencer_id: props.selectCampaign.influencerId } });
                }
            }    
        } catch (error) {
            throw new Error(
                `applyCampaign function in campaign-details.tsx :: ${error}`
            );
        }
    }

    const checkWhatsAppFlowInfluencer = async (token:any)=>{
        if (token) {
            const validateKey = await commonService.isValidToken({ token: token });
            if (validateKey.data.status.status) {
                setwhatsapp_flow(true);
                setSM_ID(validateKey.data.rows[0].sm_id);
            }
          }
    }

    const setSM_ID_Handler = () => {
        let sm_id = 0;
        const getParams = new URLSearchParams(location.search);
        let key:any = getParams.get('key');


        if(key ){
            checkWhatsAppFlowInfluencer(decodeURI(key));
        }
        else{
            if (props.UserReducer.account_type !== 'Talent Partner' ){
                for (let data of props.UserReducer?.influencer_ids) {
                    if (props.selectCampaign.campaign_platform === data?.platform_type && data.token_status === 'Connected') {
                        sm_id = data?.ig_id || data?.yt_id;
                    }
                }
            }else {
                for (let data of props.UserReducer?.influencer_ids) {
                    if ((props.selectCampaign.campaign_platform === data?.platform_type) && (data.influencer_id === props.UserReducer.influencer_id)) {
                        sm_id = data?.ig_id || data?.yt_id;
                    }
                }
            }
            if(SM_ID == sm_id){
                getApplyRestrictionData();
                getCampaignDetailForDeliverable();
            }else{
                setSM_ID(sm_id);
            }  
    
        }
    }

    async function getApplyRestrictionData() {
        const res = await listService.getApplyRestriction({
            influencerId: ((props.selectCampaign?.influencerId && props.selectCampaign?.influencerId > 0) ? props.selectCampaign?.influencerId : props.UserReducer.influencer_id),
            platform: props.selectCampaign.campaign_platform,
            smId: SM_ID,
            campaignId: props.selectCampaign.campaign_id,
            accountId: props?.UserReducer?.account_id
        });

        if (res.status === gtUtil.Constants.SUCCESS) {
            setApplyRestrictionData(res.data);
        }
    }

    const postedDate: Date | string = campaignDetail?.posted_at || '';
    const currentDate: Date = new Date();
    const daysDifference: number = methods.calculateDaysDifference(postedDate, currentDate);

    async function apply_Campaign_wf_without_signup() {
        try {
            const res = await listService.get_invited_influencer({
                influencerId: ((props.selectCampaign?.influencerId && props.selectCampaign?.influencerId > 0) ? props.selectCampaign?.influencerId : props.UserReducer.influencer_id),
                campaignId: props.selectCampaign.campaign_id,
            });
            if(res.status === gtUtil.Constants.SUCCESS){
                set_invited_number(res.data.rows[0].phone);
                handleSendOtpButton(res.data.rows[0].phone);
            }
        } catch (err) {
                console.log('error in apply_Campaign_wf_without_signup', err);
        }finally{
            set_already_user(false);
        }
    }

      const handleSendOtpButton = (number:any) => {
        let isValid: any = formValidation.GetMobileControlIsValid(number);
        if (isValid.status) {
          PublicService.whatsapp_flow_sendOtp({ mobile: +number})
            .then((res: any) => {
              if (res?.status === gtUtil.Constants.SUCCESS) {
                set_open_wf_otp(true);
              }})
            .catch((error: any) => {
              console.warn(`Otp Response Error :: ${error}`);
            });
    
        } else {
        }
      };

      const handleWhatsAppChange = (newValue: string) => {
        const filteredValue = newValue.replace(/\D/g, ''); // Replace any non-digit character
        setOtpWhatsAppValue(filteredValue);
      }

      const validateChar = (value: string) => {
        // return matchIsNumeric(value);
        return /^\d*$/.test(value);
    };

     const handleWhatsAppOtp = (otp: any) => {
        try{
        if (otp.length === 4) {
        //   setPhoneOtpVerifyLoading(true);
          PublicService.verifyOtp({ mobile: +invited_number, otp: otp })
            .then((res) => {
              if (res?.status === gtUtil.Constants.SUCCESS) {
                setPhoneOtpError(false);
                applyCampaign();
              } else {
                setPhoneOtpError(true);
              }
            })
            .catch((error) => {
              throw new Error("VerifyOtp Error ::: " + error);
            });
        }}catch(error){
          console.log('handleWhatsAppOtp error',error);
        }finally{
        //   setPhoneOtpVerifyLoading(false);
        }
      };

    return (
        <div className='campaign-det'>
            {applyButtonClass === 'Apply Now' &&
                <>
                    <CampaignDetailTitle checkInfType = {checkInfType.status} campaignDetail={campaignDetail} applyButtonClass={applyButtonClass} disabledApplyBtn={disabledApplyBtn} userReducer={props.UserReducer} applyCampaign={applyCampaign} handleOpen={handleOpen} />
                </>
            }
            <div className='inf-camp-detail'>
                <div className='camp-detail-card'>
                    <div className="camp-detail-card-left">
                        <figure className='camp-detail-img'>
                            <img
                                className='camp-cover-image w-100'
                                src={campaignDetail?.campaign_cover_url}
                                alt='cover Image'
                            />
                        </figure>
                    </div>
                    <div className="camp-detail-card-right">
                        <div className='camp-description'>
                            <span className='d-block color-blk-5d fs-14 mb-3'>Posted {`${daysDifference} days ago`}</span>
                            <strong className='camp-detail-card-sec-title'>Description</strong>

                            {myref && (
                                <div
                                    id='shortDescription'
                                    className=''
                                    ref={myref}
                                ></div>
                            )}
                        </div>
                        {campaignDetail?.about_brand && (<div className='camp-description'>
                           
                            <div style={{ fontSize: "14px", wordBreak:'break-word' }}> <strong className='camp-detail-card-sec-title d-inline-flex fs-14 mb-0'>About Brand: &nbsp; </strong>{campaignDetail?.about_brand} </div>
                        </div>
                        )}
                        {/* BRAND_WEB_URL */}
                    {campaignDetail?.reveal_brand_name === 'true' && (
                      <a
                        href={
                          campaignDetail?.brand_web_url?.startsWith('http')
                            ? campaignDetail.brand_web_url
                            : `https://${campaignDetail.brand_web_url}`
                        }
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-decoration-none d-block mt-2 word-break'
                        style={{ fontSize: '14px', fontWeight: 400, wordBreak:'break-word' }}
                      >
                        {campaignDetail?.brand_web_url}
                      </a>
                    )}
                    </div>
                </div>
                
                {/* PRODUCT DETAIL SECTION FOR BARTER + (PAID + BARTER) */}
                {(campaignDetail.campaign_type + '')
                    .toLocaleLowerCase()
                    .includes('barter') && (
                        <div className='camp-detail-card grid-2-row'>
                            <strong className='camp-detail-card-sec-title'>Product Details</strong>
                            <div className='camp-detail-card-inner'>
                                <div className='camp-detail-card-left'>
                                    <div className='product-detail-info'>
                                        <div className='product-detail-img'>
                                            <img
                                                className='product-image'
                                                src={
                                                    campaignDetail.product_image_url ? campaignDetail.product_image_url : DummyCampaignImage.default_campaign_image
                                                }
                                                alt='product cover'
                                            />
                                        </div>
                                        <div className='product-detail-price-info'>
                                            <span>
                                                {
                                                    campaignDetail.product_name
                                                }
                                            </span>
                                            <span>
                                                Worth <strong>{
                                                    campaignDetail.product_cost
                                                }</strong>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                <div className='camp-detail-card-right'>
                                    <div className='row'>
                                        {productref &&
                                            <div
                                                className='product-description'
                                                ref={productref}
                                            ></div>
                                        }
                                        {campaignDetail?.product_ref_lnk_1 && (<p><Link className='word-break' target="_blank" to={campaignDetail?.product_ref_lnk_1}>{campaignDetail?.product_ref_lnk_1}</Link></p>)}
                                        {campaignDetail?.product_ref_lnk_2 && (<p><Link className='word-break' target="_blank" to={campaignDetail?.product_ref_lnk_2}>{campaignDetail?.product_ref_lnk_2}</Link></p>)}
                                        {campaignDetail?.product_ref_lnk_3 && (<p><Link className='word-break' target="_blank" to={campaignDetail?.product_ref_lnk_3}>{campaignDetail?.product_ref_lnk_3}</Link></p>)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                {/* END PRODUCT DETAIL SECTION FOR BARTER + (PAID + BARTER) */}
                {/* DELIVERABLE SECTION */}
                <div className='camp-detail-card grid-1-col'>
                    <strong className=' camp-detail-card-sec-title'>Deliverables</strong>
                    <div className='camp-detail-card-inner grid-3-col '>
                        <DeliverableInfo deliverablesData={campaignDetailForDeliverable} loading={false} />
                    </div>
                </div>
                {/* END DELIVERABLE SECTION */}
                {/* INFLUENCER DETAILS */}
                <>
                    <div className='camp-detail-card grid-2-row'>
                        <strong className='camp-detail-card-sec-title'>Influencer Details</strong>
                        <div className='infl-det-list-sec'>
                            <div className='infl-det-list'>
                                <div className='infl-det-list-icon'>
                                    <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M23 12V17.394H22.1437V13.5097L15.9786 19.5996C16.3756 20.1573 16.6998 20.7525 16.951 21.3852C17.2023 22.0178 17.3279 22.6723 17.3279 23.3486C17.3279 24.9242 16.778 26.2599 15.6781 27.356C14.5783 28.452 13.2379 29 11.6569 29C10.076 29 8.73789 28.4518 7.64273 27.3554C6.54758 26.259 6 24.9228 6 23.3468C6 21.7707 6.54765 20.4309 7.64296 19.3274C8.73826 18.2239 10.0732 17.6721 11.6477 17.6721C12.333 17.6721 12.982 17.7996 13.5946 18.0545C14.2073 18.3093 14.7961 18.6317 15.3612 19.0214L21.5121 12.8563H17.606V12H23ZM11.6543 18.5284C10.2983 18.5284 9.15966 18.9923 8.2383 19.9201C7.31694 20.8478 6.85626 21.9897 6.85626 23.3457C6.85626 24.7017 7.31597 25.8403 8.23538 26.7617C9.1548 27.6831 10.2925 28.1437 11.6485 28.1437C13.0044 28.1437 14.1473 27.684 15.077 26.7646C16.0067 25.8452 16.4716 24.7075 16.4716 23.3515C16.4716 21.9956 16.0077 20.8527 15.0799 19.923C14.1522 18.9933 13.0103 18.5284 11.6543 18.5284Z" fill="#1C1B1F" />
                                        <path d="M0.218684 17.1025L1.9532 15.4669L0.328192 13.721L0.982798 13.1037L2.6078 14.8496L5.40471 12.2121C4.44457 10.9719 4.02073 9.57429 4.13318 8.01927C4.24563 6.46427 4.86502 5.15569 5.99137 4.09353C7.19093 2.96233 8.6073 2.41951 10.2405 2.46507C11.8736 2.5106 13.2539 3.13895 14.3812 4.35012C15.5085 5.56129 16.0436 6.9918 15.9866 8.64165C15.9296 10.2915 15.3032 11.6802 14.1074 12.8078C12.9849 13.8664 11.6454 14.3991 10.0889 14.4057C8.53248 14.4124 7.17551 13.9008 6.018 12.871L3.2211 15.5085L4.84611 17.2544L4.1915 17.8717L2.5665 16.1258L0.831981 17.7615L0.218684 17.1025ZM6.3724 11.8958C7.34358 12.9392 8.51356 13.4872 9.88233 13.5398C11.2511 13.5924 12.4538 13.13 13.4904 12.1524C14.5271 11.1748 15.0685 9.99396 15.1148 8.60978C15.1611 7.2256 14.6986 6.01179 13.7274 4.96836C12.7562 3.92492 11.586 3.38313 10.2169 3.34299C8.8477 3.30285 7.6448 3.77156 6.60816 4.74912C5.57153 5.72668 5.03028 6.90132 4.98442 8.27305C4.93855 9.64477 5.40121 10.8524 6.3724 11.8958Z" fill="#1C1B1F" />
                                    </svg>
                                </div>
                                <div className='infl-det-list-content'>
                                    <strong>Gender </strong>
                                    <ul>
                                        <li>{campaignDetail.influencer_gender}</li>
                                    </ul>
                                </div>
                            </div>
                            {campaignDetail?.categories &&
                                <div className='infl-det-list'>
                                    <div className='infl-det-list-icon'>
                                        <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.38923 10.522L12.7338 0L19.0738 10.522H6.38923ZM21.3365 28C19.7386 28 18.4002 27.4448 17.3215 26.3345C16.2427 25.2241 15.7033 23.8543 15.7033 22.2249C15.7033 20.5955 16.2428 19.2309 17.3217 18.1308C18.4007 17.0308 19.7391 16.4808 21.337 16.4808C22.9349 16.4808 24.2782 17.0309 25.3669 18.1311C26.4556 19.2313 27 20.5961 27 22.2254C27 23.8548 26.4556 25.2246 25.3667 26.3347C24.2778 27.4449 22.9344 28 21.3365 28ZM0 27.1031V17.2362H9.67629V27.1031H0ZM21.3541 26.8067C22.5927 26.8067 23.6483 26.361 24.5209 25.4696C25.3935 24.5782 25.8298 23.4959 25.8298 22.2227C25.8298 20.9495 25.3927 19.8731 24.5185 18.9935C23.6443 18.1138 22.5829 17.674 21.3343 17.674C20.0857 17.674 19.0301 18.1157 18.1675 18.999C17.3048 19.8823 16.8735 20.9636 16.8735 22.2429C16.8735 23.5059 17.3066 24.5823 18.1729 25.4721C19.0391 26.3618 20.0995 26.8067 21.3541 26.8067ZM1.17024 25.9099H8.50608V18.4295H1.17024V25.9099ZM8.44795 9.32875H17.045L12.7338 2.32723L8.44795 9.32875Z" fill="#1C1B1F" />
                                        </svg>
                                    </div>
                                    <div className='infl-det-list-content'>
                                        <strong>Category </strong>


                                        <ul>
                                            {campaignDetail?.categories?.split(",").map((cate: string) => {
                                                return <li>{cate}</li>

                                            })}
                                        </ul>
                                    </div>
                                </div>
                            }
                            <div className='infl-det-list'>
                                <div className='infl-det-list-icon'>

                                    <svg width="16" height="28" viewBox="0 0 16 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7.98399 28C5.64319 28 3.73568 27.6714 2.26146 27.0141C0.787228 26.3569 0.0501131 25.522 0.0501131 24.5096C0.0501131 24.0406 0.264657 23.5733 0.693742 23.1076C1.12285 22.6419 1.72007 22.2436 2.48539 21.9127L2.79447 22.9665C2.32884 23.1993 1.95381 23.4445 1.66939 23.702C1.38496 23.9596 1.19591 24.2287 1.10222 24.5096C1.32346 25.2433 2.08483 25.8229 3.38632 26.2484C4.68779 26.6739 6.22058 26.8866 7.98471 26.8866C9.73031 26.8866 11.2596 26.6739 12.5727 26.2484C13.8858 25.8229 14.6636 25.2433 14.9061 24.5096C14.8217 24.2533 14.631 23.9964 14.334 23.7389C14.0371 23.4814 13.653 23.2239 13.1819 22.9665L13.5284 21.9127C14.2725 22.2436 14.8621 22.6419 15.2972 23.1076C15.7323 23.5733 15.9499 24.0406 15.9499 24.5096C15.9499 25.522 15.2074 26.3569 13.7225 27.0141C12.2376 27.6714 10.3248 28 7.98399 28ZM7.98399 21.3539C8.45871 20.4329 9.01368 19.4895 9.64889 18.5236C10.2841 17.5578 10.9282 16.6365 11.5812 15.7596C12.5908 14.4532 13.3976 13.2741 14.0016 12.2222C14.6055 11.1703 14.9075 9.81709 14.9075 8.16265C14.9075 6.22806 14.233 4.56952 12.8839 3.18705C11.5348 1.80461 9.90057 1.11339 7.98109 1.11339C6.06159 1.11339 4.43361 1.80461 3.09714 3.18705C1.76068 4.56952 1.09245 6.22806 1.09245 8.16265C1.09245 9.81709 1.38911 11.1703 1.98245 12.2222C2.57576 13.2741 3.3772 14.4532 4.38679 15.7596C5.03978 16.6365 5.68388 17.5578 6.31909 18.5236C6.9543 19.4895 7.50926 20.4329 7.98399 21.3539ZM7.98515 22.8956C7.76609 22.8956 7.56038 22.8225 7.368 22.6764C7.17561 22.5303 7.05111 22.3305 6.99452 22.0772C6.33837 20.4953 5.60758 19.1741 4.80214 18.1136C3.9967 17.0532 3.24277 16.0415 2.54036 15.0788C1.80704 14.1394 1.20032 13.1409 0.720192 12.0831C0.240064 11.0254 0 9.71927 0 8.16487C0 5.88383 0.766024 3.95277 2.29807 2.37166C3.8301 0.790553 5.7254 0 7.98399 0C10.2426 0 12.1432 0.788341 13.6859 2.36502C15.2286 3.94168 16 5.87426 16 8.16276C16 9.71452 15.7561 11.0195 15.2684 12.0776C14.7806 13.1358 14.1793 14.1373 13.4644 15.0822C12.737 16.0381 11.9766 17.0478 11.1832 18.1113C10.3897 19.1747 9.66563 20.4934 9.01083 22.0673C8.93089 22.316 8.79472 22.5162 8.60232 22.6679C8.40993 22.8197 8.2042 22.8956 7.98515 22.8956ZM7.99647 9.96495C8.47151 9.96495 8.88717 9.78935 9.24346 9.43815C9.59972 9.08692 9.77785 8.65976 9.77785 8.15668C9.77785 7.67255 9.59867 7.25367 9.24031 6.90003C8.88195 6.54639 8.46213 6.36957 7.98084 6.36957C7.49958 6.36957 7.09078 6.54745 6.75444 6.9032C6.41813 7.25898 6.24998 7.68211 6.24998 8.17261C6.24998 8.68201 6.42229 9.10808 6.76693 9.45083C7.11156 9.79358 7.52141 9.96495 7.99647 9.96495Z" fill="#1C1B1F" />
                                    </svg>
                                </div>
                                <div className='infl-det-list-content'>
                                    <strong>Location </strong>
                                    <ul>
                                        {campaignDetail?.group_locations &&
                                            campaignDetail?.group_locations.trim() !== "" ?
                                            (campaignDetail?.group_locations?.split(",").map((location: string) => {
                                                return <li>{location.split(" ").join(", ")}</li>

                                            })) : <li>All Locations</li>
                                        }
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* END INFLUENCER DETAILS */}
                </>
                {/* REFERENCE LINK DETAILS */}
                { }
                {(campaignDetail.reference_link_1 || campaignDetail.reference_link_2 || campaignDetail.reference_link_3) &&
                    <div className='camp-detail-card grid-2-row'>
                        <strong className='camp-detail-card-sec-title'>Reference Links</strong>
                        <div className='camp-detail-card-left'>
                            {campaignDetail?.reference_link_1 && (<p className='reference-link'><Link target="_blank" to={campaignDetail?.reference_link_1}>{campaignDetail?.reference_link_1}</Link></p>)}
                            {campaignDetail?.reference_link_2 && (<p className='reference-link'><Link target="_blank" to={campaignDetail?.reference_link_2}>{campaignDetail?.reference_link_2}</Link></p>)}
                            {campaignDetail?.reference_link_3 && (<p className='reference-link'><Link target="_blank" to={campaignDetail?.reference_link_3}>{campaignDetail?.reference_link_3}</Link></p>)}
                        </div>
                    </div>
                }

                {/* END REFERENCE LINK DETAILS */}
                {/* COMMENTS DETAILS */}
                {campaignDetail?.comments &&
                    <div className='camp-detail-card grid-2-row'>
                        <strong className='camp-detail-card-sec-title'>Comments</strong>
                        <div className='camp-detail-card-left'>
                            <p className='commemt'>{campaignDetail?.comments}</p>
                        </div>
                    </div>
                }
                {/* END COMMENTS DETAILS */}

                {/* CAMPAIGN LIVE DATE */}

                <div className='camp-detail-card grid-2-row'>

                    <div className='infl-det-list-sec proposal-dur-info'>
                        {campaignDetail.proposal_dt &&
                            <div className='infl-det-list'>
                                <div className='infl-det-list-icon'>
                                    <span className="material-symbols-rounded">
                                        alarm
                                    </span>
                                </div>
                                <div className='infl-det-list-content'>
                                    <strong>{dayjs(campaignDetail.proposal_dt).format('LL')} </strong>
                                    <ul>
                                        <li>Proposal Deadline</li>
                                    </ul>
                                </div>
                            </div>
                        }
                        {campaignDetail.go_live_dt &&
                            <div className='infl-det-list'>
                                <div className='infl-det-list-icon'>
                                    <span className="material-symbols-rounded">
                                        calendar_month
                                    </span>
                                </div>
                                <div className='infl-det-list-content'>
                                    <strong>{dayjs(campaignDetail.go_live_dt).format('LL')} </strong>


                                    <ul>
                                        <li>Campaign Live Date</li>
                                    </ul>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {/* END CAMPAIGN LIVE DATE*/}

                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant='outlined'
                            onClick={apply_Campaign_wf_without_signup}
                        >
                            Apply without SignUp
                        </Button>
                        <Button
                            sx={{ textTransform: 'none' }}
                            variant='outlined'
                            onClick={applyWithSignUp}
                        >
                            Apply with SignUp
                        </Button>
                        {already_user && <span className='error'>You are already registered as a user. Please log in to apply for the campaign.</span>}
                    </Box>
                </Modal>
            </div>
            <div className={`d-flex justify-content-end`}>
            {/* {(props.selectCampaign?.days_old >= 1 && applyButtonClass === 'Apply Now') ? (
                 <button
                 disabled={true}
                 className={`${applyButtonClass ? "btn btn-primary  btn-rounded btn-lg" : "btn btn-primary  btn-rounded btn-lg"}`}
                 onClick={props.UserReducer == null ? handleOpen : undefined}
                >
                 {applyButtonClass}
                </button>       
                ) : (  
                    <button
                    className={`${applyButtonClass ? "btn btn-primary  btn-rounded btn-lg" : "btn btn-primary  btn-rounded btn-lg"}`}
                    onClick={props.UserReducer != null ? applyCampaign : handleOpen}
                >
                    {applyButtonClass}
                </button>
                )} */}
                {(props?.selectCampaign?.days_old < 1 && 
                    (props?.selectCampaign?.influencer_gender === "Any" || props?.UserReducer == null ||
                        props?.selectCampaign?.influencer_gender === props?.UserReducer?.gender)
                ) ? (
                    <button onClick={props?.UserReducer != null ? applyCampaign : handleOpen} className="btn btn-primary btn-mui btn-rounded btn-lg">
                    {applyButtonClass}
                </button>         
                    ) : (  
                        applyButtonClass === 'Apply Now' ?
                    <button className="btn btn-primary btn-mui btn-rounded btn-lg disabled ms-2">
                    {applyButtonClass}
                    </button> :
                    <button onClick={props?.UserReducer != null ? applyCampaign : handleOpen} className="btn btn-primary btn-mui btn-rounded btn-lg ms-2">
                    {applyButtonClass}
                </button>
                )}    
            </div>
            {props?.selectCampaign && props?.selectCampaign?.days_old >= 1 && applyButtonClass === 'Apply Now' &&
                <span className='d-flex justify-content-end' style={{ color: '#E50000', marginTop:'10px;' }} >
                    Application Closed
                </span>
            }
           
            {props?.UserReducer !== null && applyButtonClass === 'Apply Now' && (
                (props?.selectCampaign?.influencer_gender !== "Any" && (!props?.UserReducer?.gender || props?.selectCampaign?.influencer_gender !== props?.UserReducer?.gender)) ||
                checkInfType.status
            ) && (
                <span className='d-flex justify-content-end error mb-5'>
                    {props?.selectCampaign?.influencer_gender !== 'Any'
                        ? `This campaign is open to ${(props?.selectCampaign?.influencer_gender).toLowerCase()} influencers only.`
                        : 'You are not eligible to apply on this campaign.'
                    }
                </span>
            )}

            {
                applyRestrictionPopup &&
                <ApplyRestrictionPopup
                    openModal={applyRestrictionPopup}
                    onClose={(closed: boolean) => setApplyRestrictionPopup(closed)}
                    applyRestrictionData={applyRestrictionData}
                    platform={props.selectCampaign.campaign_platform}
                    stateToUpdateUserReducer = {stateToUpdateUserReducer}
                    stateToUpdateUserReducerfuntion = {(data)=>{setStateToUpdateUserReducer(data)}}
                />
            }
            {open_wf_otp &&
                <CommonPopUp
                    modalTitle="OTP send to your mobile number"
                    modalContent=""
                    openModal={open_wf_otp}
                    onClose={() => set_open_wf_otp(false)}
                    className="modal-medium mx-auto"
                >
                    <div className='mb-4'>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12  mb-3">         
                          <div className="mobile-verification">
                          <MuiOtpInput
                            className="otp-fields"
                            value={otpWhatsAppValue}
                            onChange={handleWhatsAppChange}
                            length={4}
                            autoFocus
                            TextFieldsProps={{ size: 'small', placeholder: '0', type:"tel"  }}
                            validateChar={validateChar} 
                            />
                            
                            <LoadingButton
                            className="verify-button"
                            // loading={phoneOtpVerifyloading}
                            variant="contained"
                            color="success"
                            disabled={otpWhatsAppValue.length == 4 ? false : true}
                            onClick={()=>handleWhatsAppOtp(otpWhatsAppValue)}
                          >
                            Verify
                          </LoadingButton>
                          </div>
                          {phoneOtpError && <span className="error">Wrong One Time Password (OTP)</span>}
                      </div>
                    </div>
                </CommonPopUp>
            }
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        UserReducer: state.UserReducer.UserData,
        UserID: state.UserID.userID,
        selectCampaign: state.InfSelectCamp.campaign,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loading: (data: any) => dispatch(Loading(data)),
    };
};

const connectToRedux = connect(
    mapStateToProps,
    mapDispatchToProps
)(CampaignDetails);

export { connectToRedux as CampaignDetails };
